import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {City} from '../model/index';

@Injectable()
export class CityService {
    constructor(private http: Http) {
    }

    getAll(page: number = 1) {
        return this.http.get('cities?page=' + page).map((response: Response) => response.json());
    }

    getAllCities() {
        return this.http.get('cities/all').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('cities/' + _id).map((response: Response) => response.json());
    }

    create(city: City) {
        return this.http.post('cities', city);
    }

    update(city: City) {
        return this.http.put('cities/' + city.id, city);
    }

    delete(_id: string) {
        return this.http.delete('cities/' + _id);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/city.service.ts